<template>
    <div class="a3d" v-if="total > 0 && ((file.archived > 0 && showArchived) || (file.unarchived >= 0 && !showArchived))">
        <div class="file job" @click="toggleJobs()">
            <div style="margin-right:1em;height:1px;">
            </div>
            <div class="file-name-block">
                <div class="file-name">{{file.name}}</div>
            </div>
            <div class="toggleIcon">
                <i class="fa" :class="{'fa-chevron-up': isOpen, 'fa-chevron-down': !isOpen}"></i>
            </div>
        </div>
        <template v-if="isOpen">
            <template v-for="(job, jI) in file.jobs" v-if="!(job.parentPathKey || (job.isNested || job.nestedJobName))">
                <div v-if="!showArchived && job.outputsLoaded && Array.isArray(job.jobOutputs) && job.jobOutputs.length === 0" style="margin-left:30px;">
                    <div class="job jobout">
                        <div style="flex: 3">
                            <div class="name">Unfinished job</div>
                            <div class="date">{{job.createdAt | dateFormat}}</div>
                        </div>
                        <div>
                            <template v-if="subscription || user.credits.length > 0">
                                <button class="a3d btn small inv"
                                        @click="createJob(job.id, job.jobPathKey)"
                                        style="margin-left:0.5em;">Create
                                </button>
                            </template>
                            <button class="a3d btn small"
                                    v-else
                                    @click="buymodal"
                                    style="margin-right:0.5em;">Buy Subscription</button>
                            <button class="a3d btn small inv"
                                    @click="removeJobConfirmation($event, file.pathKey, job.jobPathKey)"
                                    style="margin-right:0.5em;">Remove
                            </button>
                        </div>
                    </div>
                </div>
                <div v-for="(jobOutput, joI) in job.jobOutputs" :key='jobOutput.pathKey' v-if="jobOutput.isArchived === showArchived && job.hasOwnProperty('jobOutputs')" style="margin-left:30px;">
                    <template v-if="jobOutput.paidfor || subscription || jobOutput.status === 'ERROR'">
                        <div class="job jobout" @click="toggleJobsFiles(jI, joI)">
                            <input type="checkbox"
                                :id="jobOutput.jobOutputPathKey"
                                class="filled-in"
                                :checked="filesCompare[jobOutput.jobOutputPathKey]"
                                @change="toggleJobCompare({jobOutput, job})"
                                v-if="compareMode && isCost(jobOutput.outputFiles)"/>
                            <label :for="jobOutput.jobOutputPathKey"></label>
                            <div style="flex: 3">
                                <div class="name">
                                    {{ jobDescription(jobOutput.analysisId, jobOutput.objectiveId, false) }}
                                </div>
                                <div class="description" v-if="job.jobDescription">{{job.jobDescription}}</div>
                                <div class="date">{{job.createdAt | dateFormat}}</div>
                            </div>
                            <div class="jobout-buttons"
                                 v-if="jobOutput.outputFiles && jobOutput.outputFiles.length >= 0">
                                <div class="jobout-buttons-row">
                                    <template v-if="jobOutput.outputFiles && jobOutput.outputFiles.length > 0">
                                        <router-link :to="{name: 'ThreeJSViewer', params: { id: jobOutput.id, type: 'output'} }"
                                                     class='a3d btn inv small'>
                                            View
                                        </router-link>
                                    </template>
                                    <button v-if="jobOutput.isArchived"
                                            class="a3d btn small inv"
                                            :disabled="unarchivingProcess[jobOutput.jobOutputPathKey]"
                                            @click.stop="unarchiveJob({
                                              sourceFilePathKey: file.pathKey,
                                              jobPathKey: job.jobPathKey,
                                              jobOutputPathKey: jobOutput.jobOutputPathKey
                                            })">{{unarchivingProcess[jobOutput.jobOutputPathKey] ? 'Unarchiving...' : 'Unarchive'}}</button>
                                    <button v-if="!jobOutput.isArchived"
                                            class="a3d btn small inv"
                                            :disabled="archivingProcess[jobOutput.jobOutputPathKey]"
                                            @click.stop="archiveJob({
                                              sourceFilePathKey: file.pathKey,
                                              jobPathKey: job.jobPathKey,
                                              jobOutputPathKey: jobOutput.jobOutputPathKey
                                        })">{{archivingProcess[jobOutput.jobOutputPathKey] ? 'Archiving...' : 'Archive'}}</button>
                                    <button class="a3d btn small"
                                            @click.stop="resubmitJobConfirmation($event, {
                                              sourceFilePathKey: file.pathKey,
                                              filename: file.name,
                                              jobPathKey: job.jobPathKey,
                                              jobConfig: job.config,
                                              jobDescription: job.jobDescription,
                                              jobAnalysisId: jobOutput.analysisId,
                                              jobObjectiveId: jobOutput.objectiveId
                                            })">Re-Submit</button>
                                </div>
                                <div class="jobout-buttons-row"
                                     v-if="isHasOutput(jobOutput.outputFiles)">
                                    <router-link :to="{
                                                        name: 'ThreeJSViewer',
                                                        params: { id: jobOutput.id, type: 'output'},
                                                        query: {modifySupports: true}
                                                      }"
                                                 class="a3d btn inv small">Modify Supports</router-link>
                                    <button v-if="isHasLog(jobOutput.outputFiles)"
                                       class="right a3d btn small"
                                       @click.stop="fileDownload($event, {
                                        filename: isHasLog(jobOutput.outputFiles),
                                        sourceFilePathKey: file.pathKey,
                                        jobPathKey: job.jobPathKey,
                                        jobOutputPathKey: jobOutput.jobOutputPathKey,
                                        newTab: true
                                      })">Download optimization log</button>
                                    <button v-if="isHasConfigJson(jobOutput.outputFiles)"
                                       class="right a3d btn small"
                                       @click.stop="fileDownload($event, {
                                        filename: isHasConfigJson(jobOutput.outputFiles),
                                        sourceFilePathKey: file.pathKey,
                                        jobPathKey: job.jobPathKey,
                                        jobOutputPathKey: jobOutput.jobOutputPathKey,
                                        newTab: true
                                      })">Download config</button>
                                </div>
                            </div>
                            <div class="toggleIcon" v-if="jobOutput.paidfor || subscription || jobOutput.status === 'ERROR'">
                                <i class="fa" :class="{'fa-chevron-up': jobsFilesToggle[jI][joI], 'fa-chevron-down': !jobsFilesToggle[jI][joI]}"></i>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="job jobout">
                            <div>
                                <div>
                                    <i>{{ jobDescription(jobOutput.analysisId, jobOutput.objectiveId) }}</i>
                                    is not yet unlocked.
                                </div>
                                <div class="date">{{job.createdAt | dateFormat}}</div>
                            </div>
                            <div style='flex-grow:1;flex-basis:50%;align-self:center'>
                                <button v-if="user.credits.length > 0"
                                        class="right a3d btn small inv"
                                        @click.stop="unlockJob($event, jobOutput, job)"
                                        style="margin-right:0.5em;">Unlock<br>(1 credit)
                                </button>
                                <a v-else @click="buymodal" class="a3d btn small right">Buy Subscription</a>
                            </div>
                        </div>
                    </template>
                    <template v-if="jobsFilesToggle[jI][joI] && (jobOutput.paidfor || subscription || jobOutput.status === 'ERROR')">
                        <div v-if="jobOutput.outputFiles && jobOutput.outputFiles.length > 0">
                            <div v-for="(outputFile, ofI) in jobOutput.outputFiles" :key='outputFile.name'
                                 v-if='!outputFile.name.match(/\.json$/)' style="margin-left:40px">
                                <div class="job jobout jobfile"
                                     v-if="outputFile.name.match(/^1_.*_0m\.stl$/)
                                       && (!outputFile.name.match(/_compensated_0m\.stl$/)
                                       && !outputFile.name.match(/_compensated_Renishaw_0m\.stl$/)
                                       && !outputFile.name.match(/_compensated_strengthen_0m\.stl$/))">
                                    <div class="file-name-nested" v-if="outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/)">
                                        Support Structure Renishaw
                                    </div>
                                    <div class="file-name-nested" v-else-if="outputFile.name.match(/^1_magicSupp_0m\.stl$/) || outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)">
                                        Support Structure Polymer
                                    </div>
                                    <div class="file-name-nested" v-else-if="outputFile.name.match(/^1_.*_strengthen_0m\.stl$/)">
                                        Strengthening support
                                    </div>
                                    <div class="file-name-nested" v-else-if="!outputFile.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/)">
                                        Support Structure
                                    </div>
                                    <div class="button-block right">
                                        <dropdown v-if="!outputFile.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/) && !outputFile.name.match(/^1_magicSupp_0m\.stl$/) && !outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)"
                                                  @clickout="visibleJobsFilesSupport(jI, joI)"
                                                  :position="['center', 'top', 'center', 'top']"
                                                  :visible="!!(jobsFilesSupportVisible[jI][joI])">
                                            <div class="a3d btn small nowrap" @click="visibleJobsFilesSupport(jI, joI)">
                                                Download <i class="fa fa-angle-down"></i>
                                            </div>
                                            <div slot="dropdown" class="dialog no-padding">
                                                <aside class="menu">
                                                    <ul class="menu-list">
                                                        <li v-for="(outputFileNested, ofNI) in jobOutput.outputFiles"
                                                            :key='ofNI + outputFileNested.name'
                                                            v-if="outputFileNested.name.match(/^1_.*_0m\.[\S]{3}$/)
                                                              && !outputFileNested.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/)
                                                              && !outputFileNested.name.match(/_compensated_0m\.[\S]{3}$/)
                                                              && !outputFileNested.name.match(/_compensated_(Renishaw|strengthen)_0m\.[\S]{3}$/)
                                                              && !outputFileNested.name.match(/^1_polymerSupp.*_0m\.stl$/)">
                                                            <button class="a3d btn inv small"
                                                                    @click="fileDownload($event, {
                                                                      filename: outputFileNested.name,
                                                                      sourceFilePathKey: file.pathKey,
                                                                      jobPathKey: job.jobPathKey,
                                                                      jobOutputPathKey: jobOutput.jobOutputPathKey
                                                                    }); visibleJobsFilesSupport(jI, joI)">
                                                                Download {{outputFileNested.name.slice(-3).toUpperCase()}}
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </aside>
                                            </div>
                                        </dropdown>
                                        <div class="a3d btn small nowrap"
                                             v-if="outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/)"
                                             @click="fileDownload($event, {
                                               filename: outputFile.name,
                                               sourceFilePathKey: file.pathKey,
                                               jobPathKey: job.jobPathKey,
                                               jobOutputPathKey: jobOutput.jobOutputPathKey
                                             })">
                                            Download STL
                                        </div>
                                        <div class="a3d btn small nowrap"
                                             v-if="outputFile.name.match(/^1_magicSupp_0m\.stl$/) || outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)"
                                             @click="fileDownload($event, {
                                               filename: outputFile.name,
                                               sourceFilePathKey: file.pathKey,
                                               jobPathKey: job.jobPathKey,
                                               jobOutputPathKey: jobOutput.jobOutputPathKey
                                             })">
                                            Download STL
                                        </div>
                                        <div class="a3d btn small nowrap"
                                             v-if="outputFile.name.match(/^1_.*_strengthen_0m\.stl$/)"
                                             @click="fileDownload($event, {
                                               filename: outputFile.name,
                                               sourceFilePathKey: file.pathKey,
                                               jobPathKey: job.jobPathKey,
                                               jobOutputPathKey: jobOutput.jobOutputPathKey
                                             })">
                                            Download STL
                                        </div>
                                    </div>
                                </div>
                                <div class="job jobout jobfile"
                                     v-else-if="outputFile.name.match(/(.*)_output\.stl$/) || outputFile.name.match(/(.*)_new\.stl$/)">
                                    <div class="file-name-nested">
                                        Oriented Part
                                    </div>
                                    <div class="button-block right">
                                        <button class="a3d btn inv small"
                                                v-if="isCost(jobOutput.outputFiles) && outputFile.name.match(/(.*)\.stl$/)"
                                                @click="showEstimateCost($event, {
                                                          filename: 'cost.json',
                                                          sourceFilePathKey: file.pathKey,
                                                          jobPathKey: job.jobPathKey,
                                                          jobOutputPathKey: jobOutput.jobOutputPathKey
                                                        })">Estimate print costs</button>
                                        <dropdown @clickout="visibleJobsFilesPart(jI, joI, false)"
                                                  :position="['center', 'top', 'center', 'top']"
                                                  :visible="!!(jobsFilesPartVisible[jI][joI])">
                                            <div class="a3d btn small nowrap" @click="visibleJobsFilesPart(jI, joI)">
                                                Download <i class="fa fa-angle-down"></i>
                                            </div>
                                            <div slot="dropdown" class="dialog no-padding">
                                                <aside class="menu">
                                                    <ul class="menu-list">
                                                        <li v-for="(outputFileNested, ofNI) in jobOutput.outputFiles"
                                                            :key='ofNI + outputFileNested.name'
                                                            v-if="outputFileNested.name.match(/^(.*)_output\.(?!(txt)$)([^.]{3}$)/) || outputFileNested.name.match(/^.*_new\.[\S]{3}$/)">
                                                            <button class="a3d btn inv small"
                                                                    @click="fileDownload($event, {
                                                                      filename: outputFileNested.name,
                                                                      sourceFilePathKey: file.pathKey,
                                                                      jobPathKey: job.jobPathKey,
                                                                      jobOutputPathKey: jobOutput.jobOutputPathKey
                                                                    }); visibleJobsFilesPart(jI, joI)">
                                                                Download {{outputFileNested.name.slice(-3).toUpperCase()}}
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </aside>
                                            </div>
                                        </dropdown>
                                    </div>
                                </div>
                            </div>
                            <div style="margin-left:40px" v-if="getTempList(jI, joI).length" @click="toggleTemperatureFiles(jI, joI)">
                              <div class="job jobout jobfile" >
                                <div class="file-name-nested">
                                  Temperature
                                </div>
                                <div class="button-block right">
                                  <div class="a3d btn small nowrap"
                                    @click="allFilesDownload($event, {
                                      list: getTempList(jI, joI),
                                      sourceFilePathKey: file.pathKey,
                                      jobPathKey: job.jobPathKey,
                                      jobOutputPathKey: jobOutput.jobOutputPathKey
                                    })">
                                      Download all
                                  </div>
                                </div>
                                <div class="toggleIcon">
                                  <i class="fa" :class="{'fa-chevron-up': temperatureFilesToggle[jI, joI], 'fa-chevron-down': !temperatureFilesToggle[jI][joI]}"></i>
                                </div>
                              </div>
                              <template v-if="temperatureFilesToggle[jI][joI]">
                                <div style="margin-left: 40px">
                                  <div class="job jobout jobfile" v-for="(tempFile, i) in getTempList(jI, joI)" :key="'tempDec' + i">
                                    <div class="file-name-nested">
                                      {{ tempFile.name }}
                                    </div>
                                    <div class="button-block right">
                                      <div class="a3d btn small nowrap"
                                            @click="fileDownload($event, {
                                              filename: tempFile.name,
                                              sourceFilePathKey: file.pathKey,
                                              jobPathKey: job.jobPathKey,
                                              jobOutputPathKey: jobOutput.jobOutputPathKey
                                            })">
                                          Download
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </div>
                        </div>
                        <div v-else>
                            <div style="margin-left:40px">
                                <div class="job jobout job-status">
                                    <div class="job-status-message">
                                        {{ displayMessage(jobOutput.status) }}
                                        <span v-if="jobOutput.status === 'PROCESSING'">{{jobOutput.progress}}%</span>
                                    </div>
                                    <div class="progress" v-if="jobOutput.status === 'PROCESSING'">
                                        <div class="determinate" :style="{width: jobOutput.progress + '%'}"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="job jobout" v-if="isHasCompensated(jobOutput.outputFiles) && (jobOutput.paidfor || subscription)" @click="toggleJobsFilesCompensated(jI, joI)">
                        <div style="flex: 3">
                            <div class="name">
                                {{ jobDescription(jobOutput.analysisId, jobOutput.objectiveId, true) }}
                            </div>
                            <div class="date">{{job.createdAt | dateFormat}}</div>
                        </div>
                        <div class="jobout-buttons">
                            <div class="jobout-buttons-row">
                                <router-link :to="{name: 'ThreeJSViewer', params: { id: jobOutput.id, type: 'output'}, query: {compensated: true}}"
                                             class='a3d btn inv small'>
                                    View
                                </router-link>
                            </div>
                        </div>
                        <div class="toggleIcon">
                            <i class="fa" :class="{'fa-chevron-up': jobsFilesCompensatedToggle[jI][joI], 'fa-chevron-down': !jobsFilesCompensatedToggle[jI][joI]}"></i>
                        </div>
                    </div>
                    <template v-if="jobOutput.outputFiles && jobOutput.outputFiles.length > 0 && jobsFilesCompensatedToggle[jI][joI] && (jobOutput.paidfor || subscription)">
                        <div v-for="(outputFile, ofI) in jobOutput.outputFiles" :key='outputFile.name + "_compensated"'
                             v-if='!outputFile.name.match(/\.json$/)' style="margin-left:40px">
                            <div class="job jobout jobfile"
                                 v-if="outputFile.name.match(/_compensated_0m\.stl$/) || outputFile.name.match(/_compensated_Renishaw_0m\.stl$/) || outputFile.name.match(/_compensated_strengthen_0m\.stl$/)">
                                <div class="file-name-nested" v-if="outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/)">
                                    Support Structure Renishaw
                                </div>
                                <div class="file-name-nested" v-else-if="outputFile.name.match(/^1_magicSupp_0m\.stl$/) || outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)">
                                    Support Structure Polymer 
                                </div>
                                <div class="file-name-nested" v-else-if="outputFile.name.match(/^1_.*_strengthen_0m\.stl$/)">
                                    Strengthening support
                                </div>
                                <div class="file-name-nested" v-else-if="!outputFile.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/)">
                                    Support Structure
                                </div>
                                <div class="button-block right">
                                    <dropdown v-if="!outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/) && !outputFile.name.match(/^1_magicSupp_0m\.stl$/) && !outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)"
                                              @clickout="visibleJobsFilesSupportCompensated(jI, joI)"
                                              :position="['center', 'top', 'center', 'top']"
                                              :visible="!!(jobsFilesSupportCompensatedVisible[jI][joI])">
                                        <div class="a3d btn small nowrap"
                                             @click="visibleJobsFilesSupportCompensated(jI, joI)">
                                            Download <i class="fa fa-angle-down"></i>
                                        </div>
                                        <div slot="dropdown" class="dialog no-padding">
                                            <aside class="menu">
                                                <ul class="menu-list">
                                                    <li v-for="(outputFileNested, ofNI) in jobOutput.outputFiles"
                                                        :key='ofNI + outputFileNested.name'
                                                        v-if="outputFileNested.name.match(/^1_.*_0m\.[\S]{3}$/)
                                                          && !outputFileNested.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/)
                                                          && !outputFileNested.name.match(/^1_magicSupp_0m\.stl$/)
                                                          && !outputFileNested.name.match(/^1_polymerSupp.*_0m\.stl$/)
                                                          && (outputFileNested.name.match(/_compensated_0m\.[\S]{3}$/)
                                                          || outputFileNested.name.match(/_compensated_Renishaw_0m\.[\S]{3}$/))">
                                                        <button class="a3d btn inv small"
                                                                @click="fileDownload($event, {
                                                                        filename: outputFileNested.name,
                                                                        sourceFilePathKey: file.pathKey,
                                                                        jobPathKey: job.jobPathKey,
                                                                        jobOutputPathKey: jobOutput.jobOutputPathKey
                                                                      }); visibleJobsFilesSupportCompensated(jI, joI)">
                                                            Download {{outputFileNested.name.slice(-3).toUpperCase()}}
                                                        </button>
                                                    </li>
                                                </ul>
                                            </aside>
                                        </div>
                                    </dropdown>
                                    <div class="a3d btn small nowrap"
                                         v-if="outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/)"
                                         @click="fileDownload($event, {
                                                 filename: outputFile.name,
                                                 sourceFilePathKey: file.pathKey,
                                                 jobPathKey: job.jobPathKey,
                                                 jobOutputPathKey: jobOutput.jobOutputPathKey
                                               })">
                                        Download STL
                                    </div>
                                    <div class="a3d btn small nowrap"
                                         v-if="outputFile.name.match(/^1_magicSupp_0m\.stl$/) || outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)"
                                         @click="fileDownload($event, {
                                                 filename: outputFile.name,
                                                 sourceFilePathKey: file.pathKey,
                                                 jobPathKey: job.jobPathKey,
                                                 jobOutputPathKey: jobOutput.jobOutputPathKey
                                               })">
                                        Download STL
                                    </div>
                                    <div class="a3d btn small nowrap"
                                         v-if="outputFile.name.match(/^1_.*_strengthen_0m\.stl$/)"
                                         @click="fileDownload($event, {
                                                 filename: outputFile.name,
                                                 sourceFilePathKey: file.pathKey,
                                                 jobPathKey: job.jobPathKey,
                                                 jobOutputPathKey: jobOutput.jobOutputPathKey
                                               })">
                                        Download STL
                                    </div>
                                </div>
                            </div>
                            <div class="job jobout jobfile"
                                 v-else-if="outputFile.name.match(/output_compensated\.stl$/)">
                                <div class="file-name-nested">
                                    Oriented Part
                                </div>
                                <div class="button-block right">
                                    <button class="a3d btn inv small nowrap"
                                            v-if="isCost(jobOutput.outputFiles) && outputFile.name.match(/(.*)\.stl$/)"
                                            @click="showEstimateCost($event, {
                                                      filename: 'cost.json',
                                                      sourceFilePathKey: file.pathKey,
                                                      jobPathKey: job.jobPathKey,
                                                      jobOutputPathKey: jobOutput.jobOutputPathKey
                                                    })">Estimate print costs</button>
                                    <dropdown @clickout="visibleJobsFilesPartCompensated(jI, joI)"
                                              :position="['center', 'top', 'center', 'top']"
                                              :visible="!!(jobsFilesPartCompensatedVisible[jI][joI])">
                                        <div class="a3d btn small nowrap" @click="visibleJobsFilesPartCompensated(jI, joI)">
                                            Download <i class="fa fa-angle-down"></i>
                                        </div>
                                        <div slot="dropdown" class="dialog no-padding">
                                            <aside class="menu">
                                                <ul class="menu-list">
                                                    <li v-for="(outputFileNested, ofNI) in jobOutput.outputFiles"
                                                        :key='ofNI + outputFileNested.name'
                                                        v-if="outputFileNested.name.match(/output_compensated\.[\S]{3}$/)">
                                                        <button class="a3d btn inv small"
                                                                @click="fileDownload($event, {
                                                                          filename: outputFileNested.name,
                                                                          sourceFilePathKey: file.pathKey,
                                                                          jobPathKey: job.jobPathKey,
                                                                          jobOutputPathKey: jobOutput.jobOutputPathKey
                                                                        }); visibleJobsFilesPartCompensated(jI, joI)">
                                                            Download {{outputFileNested.name.slice(-3).toUpperCase()}}
                                                        </button>
                                                    </li>
                                                </ul>
                                            </aside>
                                        </div>
                                    </dropdown>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </template>
            <div class="progress" v-if="isLoading">
                <div class="indeterminate">
                </div>
            </div>
            <div class="load-more" v-if="isCanLoadMore && !isLoading">
                <div class="job jobout align-center">
                    <button class="a3d btn inv" @click="loadMore(loaded)">Load more</button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
  import {mapState, mapGetters, mapActions} from 'vuex'
  import errorHandling from '../../mixins/errorHandling'
  import filesOutput from '../../mixins/filesOutput'
  import dropdown from 'vue-my-dropdown'

  export default {
    components: {
      dropdown
    },
    name: 'FileOutput',
    props: ['file', 'showArchived', 'compareMode'],
    mixins: [errorHandling, filesOutput],
    data () {
      return {
        jobsLoadingLimit: 10,
        idsToLoad: [],
        jobsLoaded: 0,
        idsToLoadArchived: [],
        jobsLoadedArchived: 0
      }
    },
    computed: {
      ...mapState([
        'user',
        'gettingFileURL',
        'jobs',
        'filesCompare'
      ]),
      ...mapGetters({
        subscription: 'user/subscriptionExpiration'
      }),
      isCanLoadMore () {
        return (this.showArchived && this.idsToLoadArchived.length > 0) ||
          (!this.showArchived && this.idsToLoad.length > 0)
      },
      total () {
        return this.file.jobs.length
      }
    },
    methods: {
      ...mapActions([
        'getJobOutputs',
        'getJobsOutputs',
        'redeemJob',
        'getDownloadURL',
        'setJobToCompare',
        'removeJobFromCompare',
        'getURLData'
      ]),
      ...mapActions({
        refreshCredits: 'user/refreshCredits'
      }),
      toggleJobs () {
        this.isOpen = !this.isOpen
        if (this.isOpen && ((!this.showArchived && this.jobsLoaded === 0) || (this.showArchived && this.jobsLoadedArchived === 0))) {
          this.loadMore()
        }
      },
      toggleJobCompare (job) {
        this.filesCompare[job.jobOutput.jobOutputPathKey] ? this.removeJobFromCompare(job) : this.setJobToCompare(job)
      },
      getTempList (jI, joI) {
        return this.file.jobs[jI].jobOutputs[joI].outputFiles.reduce((acc, file) => {
          if (file.name.match(/^temp\d*\.vtk/i)) acc.push(file)
          return acc
        }, []).sort((a, b) => {
          const getNumber = (str) => +str.match(/\d+/)[0] || 1
          const [n1, n2] = [getNumber(a.name), getNumber(b.name)]
          if (n1 > n2) return 1
          else return -1
        })
      },
      loadMore () {
        let requestIdsFiltered = []
        if (this.showArchived) {
          requestIdsFiltered = this.idsToLoadArchived.slice(
            0,
            this.idsToLoadArchived.length > this.jobsLoadingLimit ? this.jobsLoadingLimit : this.idsToLoadArchived.length
          )
        } else {
          requestIdsFiltered = this.idsToLoad.slice(
            0,
            this.idsToLoad.length > this.jobsLoadingLimit ? this.jobsLoadingLimit : this.idsToLoad.length
          )
        }
        const requestIds = requestIdsFiltered
        this.isLoading = true
        this.getJobsOutputs({
          sourceFilePathKey: this.file.pathKey,
          ids: requestIds
        })
          .then((response) => {
            response.forEach((job) => {
              if (job.jobOutputs && job.jobOutputs.length > 0) {
                const unfinishedJobs = this.countUnfinishedJobs(job.jobOutputs)
                if (unfinishedJobs > 0) {
                  this.getJobsProgress({jobPathKey: job.pathKey, sourceFilePathKey: this.file.pathKey})
                }
              }
            })
            this.calculateIds()
            this.loaded += this.fileLoadingLimit
            this.isLoading = false
          })
          .catch((err) => {
            this.isLoading = false
            this.errorHandling(err, this.loadMore)
          })
      },
      toggleJobsFiles (jobIndex, index) {
        const jobsFilesToggle = this.jobsFilesToggle.slice()
        jobsFilesToggle[jobIndex][index] = !jobsFilesToggle[jobIndex][index]
        this.$set(this, 'jobsFilesToggle', jobsFilesToggle)
      },
      toggleTemperatureFiles (jobIndex, index) {
        const temperatureFilesToggle = this.temperatureFilesToggle.slice()
        temperatureFilesToggle[jobIndex][index] = !temperatureFilesToggle[jobIndex][index]
        this.$set(this, 'temperatureFilesToggle', temperatureFilesToggle)
      },
      toggleJobsFilesCompensated (jobIndex, index) {
        const jobsFilesCompensatedToggle = this.jobsFilesCompensatedToggle.slice()
        jobsFilesCompensatedToggle[jobIndex][index] = !jobsFilesCompensatedToggle[jobIndex][index]
        this.$set(this, 'jobsFilesCompensatedToggle', jobsFilesCompensatedToggle)
      },
      visibleJobsFilesSupport (jobIndex, index) {
        const jobsFilesSupportVisible = this.jobsFilesSupportVisible.slice()
        jobsFilesSupportVisible[jobIndex][index] = !jobsFilesSupportVisible[jobIndex][index]
        this.$set(this, 'jobsFilesSupportVisible', jobsFilesSupportVisible)
      },
      visibleJobsFilesSupportCompensated (jobIndex, index) {
        const jobsFilesSupportCompensatedVisible = this.jobsFilesSupportCompensatedVisible.slice()
        jobsFilesSupportCompensatedVisible[jobIndex][index] = !jobsFilesSupportCompensatedVisible[jobIndex][index]
        this.$set(this, 'jobsFilesSupportCompensatedVisible', jobsFilesSupportCompensatedVisible)
      },
      visibleJobsFilesPart (jobIndex, index) {
        const jobsFilesPartVisible = this.jobsFilesPartVisible.slice()
        jobsFilesPartVisible[jobIndex][index] = !jobsFilesPartVisible[jobIndex][index]
        this.$set(this, 'jobsFilesPartVisible', jobsFilesPartVisible)
      },
      visibleJobsFilesPartCompensated (jobIndex, index) {
        const jobsFilesPartCompensatedVisible = this.jobsFilesPartCompensatedVisible.slice()
        jobsFilesPartCompensatedVisible[jobIndex][index] = !jobsFilesPartCompensatedVisible[jobIndex][index]
        this.$set(this, 'jobsFilesPartCompensatedVisible', jobsFilesPartCompensatedVisible)
      },
      unlockJob (event, jobOutput, job) {
        const defaultMessage = event.target.innerHTML
        event.target.innerHTML = 'Unlocking...'
        event.target.disabled = true
        this.redeemJob(jobOutput.jobOutputPathKey)
          .then(() => {
            return this.getJobOutputs({jobPathKey: job.jobPathKey, sourceFilePathKey: job.sourceFilePathKey})
          })
          .then(() => {
            return this.refreshCredits()
          })
          .catch((err) => {
            this.errorHandling(err)
            event.target.innerHTML = defaultMessage
            event.target.disabled = false
          })
      },
      archiveJob (payload) {
        this.$set(this.archivingProcess, payload.jobOutputPathKey, true)
        this.$store.dispatch('_jobs/archiveJob', {jobOutputPathKey: payload.jobOutputPathKey})
          .then((response) => {
            payload.isArchived = true
            this.$store.commit('ARCHIVE_JOB_OUTPUT', payload)
            this.$set(this.archivingProcess, payload.jobOutputPathKey, false)
            this.calculateIds()
          })
          .catch((err) => {
            this.errorHandling(err, () => {
              this.archiveJob(payload)
            })
            this.$set(this.archivingProcess, payload.jobOutputPathKey, false)
          })
      },
      unarchiveJob (payload) {
        this.$set(this.unarchivingProcess, payload.jobOutputPathKey, true)
        this.$store.dispatch('_jobs/unarchiveJob', {jobOutputPathKey: payload.jobOutputPathKey})
          .then((response) => {
            payload.isArchived = false
            this.$store.commit('ARCHIVE_JOB_OUTPUT', payload)
            this.$set(this.unarchivingProcess, payload.jobOutputPathKey, false)
            this.calculateIds()
          })
          .catch((err) => {
            this.errorHandling(err, () => {
              this.archiveJob(payload)
            })
            this.$set(this.unarchivingProcess, payload.jobOutputPathKey, false)
          })
      },
      calculateIds () {
        this.idsToLoad = []
        this.idsToLoadArchived = []
        this.jobsLoaded = 0
        this.jobsLoadedArchived = 0
        this.file.jobs.forEach((job) => {
          if (!Array.isArray(job.jobOutputs)) {
            if (job.unarchived > 0 && job.archived > 0) {
              this.idsToLoad.push(job.jobId)
              this.idsToLoadArchived.push(job.jobId)
            } else if (job.unarchived > 0 || (job.archived === 0 && job.unarchived === 0)) {
              this.idsToLoad.push(job.jobId)
            } else {
              this.idsToLoadArchived.push(job.jobId)
            }
          } else {
            if (job.unarchived > 0 && job.archived > 0) {
              this.jobsLoaded++
              this.jobsLoadedArchived++
            } else if (job.unarchived > 0 || (job.archived === 0 && job.unarchived === 0)) {
              this.jobsLoaded++
            } else {
              this.jobsLoadedArchived++
            }
          }
        })
      }
    },
    created () {
      this.file.jobs.forEach((job, index) => {
        this.jobsFilesToggle[index] = []
        this.jobsFilesCompensatedToggle[index] = []
        this.temperatureFilesToggle[index] = []
        this.jobsFilesSupportVisible[index] = []
        this.jobsFilesSupportCompensatedVisible[index] = []
        this.jobsFilesPartVisible[index] = []
        this.jobsFilesPartCompensatedVisible[index] = []
      })
      this.calculateIds()
    },
    beforeDestroy () {
      if (this.timers.length > 0) {
        this.timers.forEach((timer) => {
          clearTimeout(timer)
        })
      }
    },
    watch: {
      showArchived (value, oldValue) {
        if (this.isOpen && ((value && this.idsToLoadArchived.length > 0 && this.jobsLoadedArchived < 10) ||
          (!value && this.idsToLoad.length > 0 && this.jobsLoaded < 10))) {
          this.loadMore()
        }
      }
    },
    filters: {
      dateFormat: function (value) {
        return new Date(value).toLocaleString({
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    .a3d {
        .file {
            margin: 0.5em 0;
            padding: 1em;
            display: inline-flex;
            width: 100%;
            background-color: $bg-gray;

            .file-name-block {
                flex-grow: 1;
                display: flex;
                flex-direction: column;

                .file-name {
                    word-break: break-all;
                    flex-grow: 1;
                    font-size:1.3em;
                    font-weight:bold;
                    padding-right: 4px;
                }

                .file-date {
                    font-size: 14px;
                }
            }
        }
        .job {
            background-color: #FFFFFF;
            display: flex;
        }
        .jobout {
            margin: 0.5em 0;
            padding: 1em;
            width: 100%;
            align-items: center;
            .name {
                font-size: 1.2em;
            }
            .description {
                font-size: 16px;
            }
            .date {
                font-size: 14px;
            }
        }
        .job-status {
            flex-direction: column;
            .job-status-message {
                align-self: flex-start;
            }
        }
        .jobout-buttons {
            padding-top:1px;
            margin-left:24px;
            display: flex;
            flex-direction: column;
            flex: 2;

            .jobout-buttons-row {
                display: flex;
                flex-direction: row-reverse;
                padding-bottom: 6px;
                .btn {
                    margin: auto 0 auto 6px;
                }
            }
        }
        .toggleIcon {
            padding-left: 16px;
            cursor: pointer;
            align-self: center;
        }
        .align-right {
            justify-content: flex-end;
        }
        .align-center {
            justify-content: center;
        }
        .btn.nowrap {
            white-space: nowrap;
            display: block;
        }
        .button-block {
            display: flex;
            text-align: right;
            min-width: 120px;
            justify-content: flex-end;
            flex: 3;

            .btn {
                margin-left: 4px;

                i {
                    font-size: 0.9rem;
                }
            }

            .menu {
                .btn {
                    width: 100%;
                    margin-bottom: 0!important;
                }
            }
        }
    }
    .file-name-nested {
        flex: 2;
    }
    .load-more {
        margin-left: 30px;
        .btn {
            width: 95%;
        }
    }

    @media (max-width: 1400px) {
        #section-body {
            .jobs {
                .jobfile {
                    .button-block {
                        flex-direction: column;

                        .btn {
                            margin-bottom: 4px;
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 1200px) {
        #section-body {
            .files {
                .button-block {
                    flex-direction: column;

                    .btn {
                        margin-bottom: 4px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// FileOutput.vue?747feaa3